export const generateBase64ImageUrl = (base64Data, mimeType = "image/png") => {
  return `data:${mimeType};base64,${base64Data}`;
};
